import {find, pipe} from '@yandex-delivery/utils'

// TODO: переделать на конфиг
const phoneSubstitutionList: [string | RegExp, string][] = [
  ['0', '+972'],
  ['8', '+7'],
]

export const getDigits = (phone: string) => phone?.replace(/\D/g, '')

/**
 * Заменяет у телефона префикс согласно конфигу.
 * Прим.: 050 000 0000 -> +972 50 000 0000
 */
export const phoneLocalToGlobal = (phone?: string) =>
  phone &&
  pipe(
    phoneSubstitutionList,
    // находим пару с подходящим префиксом
    find(([fst]) => (typeof fst === 'string' ? phone.startsWith(fst) : fst.test(phone))),
    // если нашли, меняем его. Если нет, ничего не делаем
    pair => (!!pair ? phone.replace(...pair) : phone),
  )

/**
 * Форматирует номер телефона по маске
 * @param value - input value 
 * @param mask - маска (например "+xxx xx xx x xxxxx" или "+x (xxx) xxx-xxxxx xx")
 * @returns телефон форматированный с маской
 * 
 * @example
 * formatWithMask("2250712345098", "+xxx xx xx x xxxxx")
 * // Returns: "+225 07 12 3 45098"
 */
export function formatWithMask(value: string, mask: string): string {
  const digits = value.replace(/\D/g, '');
  
  if (!digits) {
    return '';
  }
  
  let result = '';
  let digitIndex = 0;
  
  for (let i = 0; i < mask.length && digitIndex < digits.length; i++) {
    const maskChar = mask[i];
    
    if (maskChar === 'x') {
      result += digits[digitIndex];
      digitIndex++;
    } else {
      result += maskChar;
    }
  }
  
  if (digitIndex < digits.length) {
    result += digits.slice(digitIndex);
  }
  
  return result;
}
